module.exports = __webpack_public_path__ + "static/media/pc-bud.5e60336e.jpg";